<template>
    <div class="popup" :class="className" v-show="visible" @click="maskClickHandle">
		<div class="popup_container" :class="contentClass" @click.stop>
			<div class="popup_header">
				<div class="popup_header-title" :class="align" v-if="title || showClose">
					<slot name="title">{{title}}</slot>
				</div>
				<img class="popup_header-close" src="@/assets/images/icon/icon_dialog_close@3x.png" v-if="showClose" @click="close" />
			</div>
			<div class="popup_content" @click.stop>
				<slot></slot>
			</div>
		</div>
    </div>
</template>
<script>
export default {
    name: 'Popup',
    props:{
        type: {
            type: String,
            default: 'center'
        },
        showMask: {
            type: Boolean,
            default: true
        },
        maskClick:{
            type: Boolean,
            default: true
        },
        title: String,
        showClose: {
            type: Boolean,
            default: false
        },
        align: {
            type: String,
            default: 'left',
            validator: value=>['left', 'center'].includes(value)
        }
    },
    data(){
        return {
            visible: false,
            aniClass: ''
        }
    },
    mounted(){
        //添加到页面第一层
        let pages = document.querySelectorAll('#app>div');
        let appPage = pages[pages.length - 1] || document.body;
        appPage.appendChild(this.$el);
    },
    computed: {
        className(){
            let className = `is-${this.type}`;
            if(this.showMask){
                className += ' is-mask';
            }
            return className;
        },
        contentClass(){
            return `${this.aniClass}`
        },
        closeDelay(){
            return this.type == 'center' ? 0 : 300;
        }
    },
    methods:{
        open(){
            this.aniClass = 'out';
            this.visible = true;
        },
        close(){
            this.aniClass = 'in';
            setTimeout(() => {
                this.visible = false;
                this.aniClass = '';
                this.$emit('close-animation-end');
            }, this.closeDelay);
        },
        maskClickHandle(){
            if(!this.showMask || !this.maskClick) return;
            this.close();
        }
    }
}
</script>
<style lang="scss" scope>
.popup{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 950;
	&.is-mask{
        background: rgba(0,0,0,0.6);
		.popup_container{
			box-shadow: none;
		}
	}
	&.is-center{
        display: flex;
        align-items: center;
        justify-content: center;
		.popup_container{
			border-radius: 20px;
		}
	} 
	&.is-top{
		.popup_container{
			width: 100%;
			border-radius: 0px 0px 40px 40px;
            position: absolute;
            left: 0;
            top: 0;
            &.out{
                transform: translateY(0%);
                animation: top-out 0.3s linear;
            }
            &.in{
                transform: translateY(-100%);
                animation: top-in 0.3s linear;
            }
			.popup_content{
				width: 100%;
			}
		}
	} 
	&.is-bottom{
		.popup_container{
			width: 100%;
			padding-bottom: var(--safe-area-inset-bottom);
			box-sizing: border-box;
			border-radius: 40px 40px 0px 0px;
            position: absolute;
            left: 0;
            bottom: 0;
            &.out{
                transform: translateY(0%);
                animation: bottom-out 0.3s linear;
            }
            &.in{
                transform: translateY(100%);
                animation: bottom-in 0.3s linear;
            }
			.popup_content{
				width: 100%;
				box-sizing: border-box;
			}
		}
	}
    .popup_container{
		height: auto;
		width: auto;
		background: #FFFFFF;
		box-shadow: 0px 6px 20px -4px rgba(136,136,136,0.25);
		.popup_header{
			height: auto;
			width: 100%;
			padding: 34px 40px 0;
			box-sizing: border-box;
			margin-bottom: 16px;
			position: relative;
			.popup_header-title{
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 32px;
				color: #1B1C1E;
				line-height: 44px;
				&.left{
					text-align: left;
				}
				&.center{
					text-align: center;
				}
			}
			.popup_header-close{
				width: 48px;
				height: 48px;
				position: absolute;
				top: 32px;
				right: 32px;
			}
		}
		.popup_content{
			height: auto;
			width: auto;
		}
	}
}
@keyframes top-out{
    0%{
        transform: translateY(-100%);
    }
    100%{
        transform: translateY(0%);
    }
}
@keyframes top-in{
    0%{
        transform: translateY(0%);
    }
    100%{
        transform: translateY(-100%);
    }
}
@keyframes bottom-out{
    0%{
        transform: translateY(100%);
    }
    100%{
        transform: translateY(0%);
    }
}
@keyframes bottom-in{
    0%{
        transform: translateY(0%);
    }
    100%{
        transform: translateY(100%);
    }
}
</style>